module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "all-reports"
    }
  }, [_c('h2', [_vm._v("All Reports")]), _c('b-button-toolbar', [_c('b-button-group', {
    staticClass: "mx-1"
  }, [_c('b-button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onExport.apply(null, arguments)
      }
    }
  }, [_vm._v("Export")])], 1), _c('b-button-group', {
    staticClass: "mx-1"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: ('modalUploadReports'),
      expression: "'modalUploadReports'"
    }]
  }, [_vm._v("Import")]), _c('b-modal', {
    ref: "modalUploadReports",
    attrs: {
      "id": "modalUploadReports",
      "size": "lg",
      "title": "Upload reports file"
    },
    on: {
      "ok": function($event) {
        return _vm.$refs.importForm.submit()
      }
    }
  }, [_vm._t("modal-header", function() {
    return [_c('b-alert', {
      staticClass: "alert-danger",
      attrs: {
        "show": "show"
      }
    }, [_vm._v("Danger! Importing reports will\n"), _c('strong', [_vm._v("delete all existing reports")]), _vm._v(" before adding the new ones.\nUse with caution.")])]
  }), _c('form', {
    ref: "importForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('b-form-file', {
    attrs: {
      "type": "file",
      "placeholder": "Add CSV file"
    },
    on: {
      "change": _vm.onImport
    },
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1), (_vm.importRows.length > 0) ? _c('div', {
    staticClass: "preview"
  }, [_c('datatable', {
    staticClass: "import-results",
    attrs: {
      "title": "Import Preview",
      "columns": _vm.columns,
      "rows": _vm.importRows
    }
  }), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.setAllReports(_vm.importRows)
      }
    }
  }, [_vm._v("Confirm Import")])], 1) : _vm._e()], 2)], 1)], 1), (_vm.allReports.length > 0) ? _c('datatable', {
    staticClass: "all-reports",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.allReports
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3985a873","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/all-reports.vue
// module id = 263
// module chunks = 1